import { type ReactNode, useContext } from 'react'

import { type AttributeInput } from '@data/shopify/storefront/types'
import { CartContext } from '@lib/cart/context'
import { StringsContext } from '@lib/strings-context'

import Button, {
  type ButtonProps,
  ButtonSize,
} from '@components/buttons/button'

type ProductAddProps = ButtonProps & {
  onClick: (customAttributes?: AttributeInput[]) => Promise<void>
  disabled?: boolean
  className?: string
  children: ReactNode
}

const ProductAdd = ({
  onClick,
  variant,
  color,
  size = ButtonSize.NORMAL,
  icon,
  disabled,
  className,
  children,
}: ProductAddProps) => {
  const { cart, isCartProductAdding } = useContext(CartContext)
  const strings = useContext(StringsContext)

  return (
    <Button
      id="product-add-to-cart-button"
      className={className}
      variant={variant}
      color={color}
      size={size}
      icon={icon}
      disabled={disabled || !cart || isCartProductAdding}
      onClick={() => onClick()}
    >
      {!cart && strings.buttonUnavailable}
      {isCartProductAdding && strings.buttonAdding}
      {cart && !isCartProductAdding && children}
    </Button>
  )
}

export default ProductAdd
